// SPDX-License-Identifier: AGPL-3.0-only

export type SystemRole = "system_admin" | "system_manager" | "system_viewer";

export function readSystemRole(roles: readonly string[]): SystemRole | null {
  const role: string | undefined = roles.find((item: string): boolean =>
    item === "system_admin" || item === "system_manager" || item === "system_viewer",
  );
  return role as SystemRole | undefined ?? null;
}

export function canViewSystem(roles: readonly string[]): boolean {
  return readSystemRole(roles) !== null;
}

export function canManageTenants(roles: readonly string[]): boolean {
  const role: SystemRole | null = readSystemRole(roles);
  return role === "system_admin" || role === "system_manager";
}

export function canManageSystemUsers(roles: readonly string[]): boolean {
  return readSystemRole(roles) === "system_admin";
}
